// extracted by mini-css-extract-plugin
export default {"HowToPlay":"HowToPlay_HowToPlay__Hp7ZO","steps":"HowToPlay_steps__cuGHp","step":"HowToPlay_step__2jjXx"};